import React, { useState, useEffect } from 'react';
import Select from '../ui/Select';
import axiosInstance from '../../api/axiosInstance';
import '../../../src/styles/settings.css';  
import '../../../src/styles/notification-settings.css';
// import { toast } from 'react-toastify'; // Commented out - using react-toast now
import { toast } from 'react-toast';
const NotificationSettings = () => {
  const [notificationSettings, setNotificationSettings] = useState({
    emailNotifications: true,
    testRunCompleted: true,
    testRunFailed: true,
    newTestCaseAdded: true,
    newSceneriosAdded: true,
    testPlanUpdated: true,
    weeklyReports: true,
    browserNotifications: true,
    desktopNotifications: false,
    mobileNotifications: false,
    emailDigest: 'daily'
  });
  const [isLoading, setIsLoading] = useState(true);

   useEffect(() => {
    const fetchNotificationSettings = async () => {
      try {
        const response = await axiosInstance.get('/user_profile/notification_settings');  

         setNotificationSettings({
          emailNotifications: response.data.email_notifications,
          testRunCompleted: response.data.test_run_completed,
          testRunFailed: response.data.test_run_failed,
          newTestCaseAdded: response.data.new_test_case_added,
          newSceneriosAdded: response.data.new_scenerios_added,
          testPlanUpdated: response.data.test_plan_updated,
          weeklyReports: response.data.weekly_reports,
          browserNotifications: response.data.browser_notifications,
          desktopNotifications: response.data.desktop_notifications,
          mobileNotifications: response.data.mobile_notifications,
          emailDigest: response.data.email_digest_frequency === 1 ? 'realtime' :
            response.data.email_digest_frequency === 2 ? 'daily' :
              response.data.email_digest_frequency === 3 ? 'weekly' : 'realtime'
        });
      } catch (error) {
        console.error('Error fetching notification settings:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchNotificationSettings();
  }, []);

   const handleToggleChange = (e) => {
    const { name, checked } = e.target;
    setNotificationSettings(prevSettings => ({
      ...prevSettings,
      [name]: checked
    }));
  };

   const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setNotificationSettings(prevSettings => ({
      ...prevSettings,
      [name]: value
    }));
  };

   const handleSubmit = async (e) => {
    e.preventDefault();

    try {
       const payload = {
        email_notifications: notificationSettings.emailNotifications,
        test_run_completed: notificationSettings.testRunCompleted,
        test_run_failed: notificationSettings.testRunFailed,
        new_test_case_added: notificationSettings.newTestCaseAdded,
        new_scenerios_added: notificationSettings.newSceneriosAdded,
        test_plan_updated: notificationSettings.testPlanUpdated,
        weekly_reports: notificationSettings.weeklyReports,
        browser_notifications: notificationSettings.browserNotifications,
        desktop_notifications: notificationSettings.desktopNotifications,
        mobile_notifications: notificationSettings.mobileNotifications,
        email_digest_frequency: notificationSettings.emailDigest === 'daily' ? 2 :
          notificationSettings.emailDigest === 'weekly' ? 3 :
            notificationSettings.emailDigest === 'realtime' ? 1 : 0
      };

      const response = await axiosInstance.put('/user_profile/notification_settings', payload);

      if (response.status === 200) {
        throw new Error('Failed to save notification settings');
      }

      console.log('Notification settings saved:', payload);
      toast.success('Notification settings updated successfully!');
    } catch (error) {
      console.error('Error saving notification settings:', error);
      const errorMessage = error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to update notification settings. Please try again.';

      toast.error(errorMessage);
    }
  };

  if (isLoading) {
    return <div className="settings-section">Loading notification settings...</div>;
  }

  return (
    <div className="settings-section">
      <div className="settings-section-intro">
        <h2 className="settings-section-title">Notifications</h2>
        <p className="settings-subtitle">Choose how and when you are notified.</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="settings-card">
          <h3 className="settings-card-title">Browser Notifications</h3>
          <p className="settings-card-description">
            
Configure which browser notifications you'd like to receive
          </p>

          <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px 20px',
              background: 'white',
              borderRadius: '8px',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
              marginBottom: '24px',
              minHeight: '80px'
            }}>
            <div>
              <div style={{ 
                fontSize: '1.1rem', 
                fontWeight: '500', 
                color: '#4361ee',
                marginBottom: '4px'
              }}>
                Browser Notifications
              </div>
              <div style={{ 
                fontSize: '0.9rem',
                color: '#718096'
              }}>
                Enable or disable all browser notifications
              </div>
            </div>
            <div style={{ 
              marginLeft: '20px',
              display: 'flex',
              alignItems: 'center'
            }}>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="emailNotifications"
                  checked={notificationSettings.emailNotifications}
                  onChange={handleToggleChange}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>
          <div style={{ height: '1px', background: '#e9ecef', margin: '24px 0' }} />

          <div className="settings-option">
            <div>
              <div className="settings-option-label">Test Run Completed</div>
              <div className="settings-option-description">Notify when a test run is completed</div>
            </div>
            <div className="settings-option-control">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="testRunCompleted"
                  checked={notificationSettings.testRunCompleted}
                  onChange={handleToggleChange}
                  disabled={!notificationSettings.emailNotifications}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>

          <div className="settings-option">
            <div>
              <div className="settings-option-label">Test Run Failed</div>
              <div className="settings-option-description">Notify when a test run fails</div>
            </div>
            <div className="settings-option-control">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="testRunFailed"
                  checked={notificationSettings.testRunFailed}
                  onChange={handleToggleChange}
                  disabled={!notificationSettings.emailNotifications}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>

          <div className="settings-option">
            <div>
              <div className="settings-option-label">New Test Case Added</div>
              <div className="settings-option-description">Notify when a new test case is added to your project</div>
            </div>
            <div className="settings-option-control">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="newTestCaseAdded"
                  checked={notificationSettings.newTestCaseAdded}
                  onChange={handleToggleChange}
                  disabled={!notificationSettings.emailNotifications}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>
          
          <div className="settings-option">
            <div>
              <div className="settings-option-label">New Scenarios Added</div>
              <div className="settings-option-description">Notify when a new scenario is added to your project</div>
            </div>
            <div className="settings-option-control">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="newSceneriosAdded"
                  checked={notificationSettings.newSceneriosAdded}
                  onChange={handleToggleChange}
                  disabled={!notificationSettings.emailNotifications}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>

          <div className="settings-option">
            <div>
              <div className="settings-option-label">Test Plan Updated</div>
              <div className="settings-option-description">Notify when a test plan is updated</div>
            </div>
            <div className="settings-option-control">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="testPlanUpdated"
                  checked={notificationSettings.testPlanUpdated}
                  onChange={handleToggleChange}
                  disabled={!notificationSettings.emailNotifications}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>

          <div className="settings-option">
            <div>
              <div className="settings-option-label">Weekly Reports</div>
              <div className="settings-option-description">Receive weekly summary reports</div>
            </div>
            <div className="settings-option-control">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="weeklyReports"
                  checked={notificationSettings.weeklyReports}
                  onChange={handleToggleChange}
                  disabled={!notificationSettings.emailNotifications}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>

          <div className="settings-option">
            <div>
              <div className="settings-option-label">Email Digest Frequency</div>
              <div className="settings-option-description">How often you want to receive email digests</div>
            </div>
            <div className="settings-option-control">
              <Select
                name="emailDigest"
                className="rt-select--form"
                value={notificationSettings.emailDigest}
                onChange={handleSelectChange}
                disabled={!notificationSettings.emailNotifications}
              >
                <option value="realtime">Real-time</option>
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
              </Select>
            </div>
          </div>
        </div>

        <div className="settings-card">
          <h3 className="settings-card-title">Other Notifications</h3>
          <p className="settings-card-description">
            Configure additional notification channels.
          </p>

          <div className="settings-option">
            <div>
              <div className="settings-option-label">Email Notifications</div>
              <div className="settings-option-description">Enable or disable all email notifications</div>
            </div>
            <div className="settings-option-control">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="browserNotifications"
                  checked={notificationSettings.browserNotifications}
                  onChange={handleToggleChange}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>

          <div className="settings-option">
            <div>
              <div className="settings-option-label">Desktop Notifications</div>
              <div className="settings-option-description">Receive notifications on your desktop</div>
            </div>
            <div className="settings-option-control">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="desktopNotifications"
                  checked={notificationSettings.desktopNotifications}
                  onChange={handleToggleChange}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>

          <div className="settings-option">
            <div>
              <div className="settings-option-label">Mobile Notifications</div>
              <div className="settings-option-description">Receive notifications on your mobile device</div>
            </div>
            <div className="settings-option-control">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="mobileNotifications"
                  checked={notificationSettings.mobileNotifications}
                  onChange={handleToggleChange}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button type="button" className="btn btn-outline">Cancel</button>
          <button type="submit" className="btn btn-primary">Save Changes</button>
        </div>
      </form>
    </div>
  );
};

export default NotificationSettings;